"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.identity = exports.prefixReferences = exports.transform = exports.indexObject = exports.isNumeric = void 0;
var ReferencesResolver_1 = require("./ReferencesResolver");
exports.isNumeric = /^[-]?\d*\.?\d+(?:[Ee][+-]?\d+)?$/;
var indexObject = function (parent, refs, data) {
    if (!data) {
        return;
    }
    Object.entries(data).forEach(function (kvPair) {
        var key = parent.length > 0 ? parent + "." + kvPair[0] : "" + kvPair[0];
        refs.set(key, kvPair[1]);
        if (typeof kvPair[1] === 'object') {
            exports.indexObject(key, refs, kvPair[1]);
        }
    });
};
exports.indexObject = indexObject;
var transform = function (data, f) {
    if (!data) {
        return f(data);
    }
    if (Array.isArray(data)) {
        var result_1 = [];
        data.forEach(function (v) {
            if (typeof v === 'object') {
                result_1.push(exports.transform(v, f));
            }
            else {
                result_1.push(f(v));
            }
        });
        return f(result_1);
    }
    else if (typeof data === 'object') {
        var result_2 = {};
        Object.entries(data).forEach(function (kvPair) {
            if (typeof kvPair[1] === 'object') {
                result_2[kvPair[0]] = exports.transform(kvPair[1], f);
            }
            else {
                result_2[kvPair[0]] = f(kvPair[1]);
            }
        });
        return f(result_2);
    }
    else if (typeof data === 'string') {
        return f(data);
    }
    else {
        return f(data);
    }
};
exports.transform = transform;
function prefixReferences(s) {
    if (typeof s !== 'string') {
        return s;
    }
    var result = s;
    return result.replace(ReferencesResolver_1.FIND_REFS, function (ref) {
        if (ref.startsWith('%%')) {
            return ref;
        }
        var firstRefCharCode = ref.charCodeAt(1);
        if (firstRefCharCode > 47 && firstRefCharCode < 58) {
            return "%" + ReferencesResolver_1.INDEX_NAMESPACE + "." + ref.substring(1);
        }
        else {
            return "%" + ReferencesResolver_1.SUBS_NAMESPACE + "." + ref.substring(1);
        }
    });
}
exports.prefixReferences = prefixReferences;
var identity = function (x) { return x; };
exports.identity = identity;
//# sourceMappingURL=Util.js.map